import { MagnetIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/components/empty-state';
import { SidePanelBody, SidePanelHeader } from '@/shared/components/side-panel';

/** What a lead panel (`?panel=lead:<id>`, also a deep link) shows while «use leads» is off: the leads are kept, not shown. */
export function LeadsOff() {
  const { t } = useTranslation('crm');
  return (
    <>
      <SidePanelHeader title={t('entities.lead')} />
      <SidePanelBody>
        <EmptyState icon={MagnetIcon} title={t('leadsOff.title')} description={t('leadsOff.text')} />
      </SidePanelBody>
    </>
  );
}
